import { useRouteLoaderData } from 'react-router-dom';
import type { RestaurantDetails } from 'webReservations/restaurant/apiHelpers';

export const useRestaurantLoaderData = (): RestaurantDetails | undefined => {
  const restaurantLoaderData = useRouteLoaderData('restaurant') as
    | RestaurantDetails
    | undefined;
  const newGuestLandingLoaderData = useRouteLoaderData(
    'newGuestLandingRestaurant',
  ) as RestaurantDetails | undefined;
  const newGuestLandingReservationLoaderData = useRouteLoaderData(
    'newGuestLandingReservation',
  ) as RestaurantDetails | undefined;

  return (
    restaurantLoaderData ??
    newGuestLandingLoaderData ??
    newGuestLandingReservationLoaderData
  );
};
